import api from './api';

const SUPPORT_TICKETS_BASE = '/support-tickets';

const supportTicketService = {
  getAll: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.search) queryParams.append('search', params.search);
    if (params.status) queryParams.append('status', params.status);
    if (params.priority) queryParams.append('priority', params.priority);
    if (params.type) queryParams.append('type', params.type);
    if (params.assignee) queryParams.append('assignee', params.assignee);
    if (params.sortBy) queryParams.append('sortBy', params.sortBy);
    if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);
    const qs = queryParams.toString();
    const response = await api.get(qs ? `${SUPPORT_TICKETS_BASE}?${qs}` : SUPPORT_TICKETS_BASE);
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`${SUPPORT_TICKETS_BASE}/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post(SUPPORT_TICKETS_BASE, data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`${SUPPORT_TICKETS_BASE}/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`${SUPPORT_TICKETS_BASE}/${id}`);
    return response.data;
  },

  getStats: async () => {
    const response = await api.get(`${SUPPORT_TICKETS_BASE}/stats`);
    return response.data;
  },

  addComment: async (id, body) => {
    const response = await api.post(`${SUPPORT_TICKETS_BASE}/${id}/comments`, { body });
    return response.data;
  }
};

export default supportTicketService;
